import { LiveCreateInput } from '@/__generated__/graphql';
import { transformToUpdate } from '@/utils/transformToUpdate';
import { useMutation } from '@apollo/client';
import { Button, Stack, TextInput } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { isNotEmpty, useForm } from '@mantine/form';
import { modals } from '@mantine/modals';
import { upsertLiveDocument } from '../graphql/mutations';

type LiveInput = Omit<LiveCreateInput, 'orders' | 'products' | 'createdAt' | 'updatedAt'>;

export const LiveUpsertModal = ({ live }: { live?: LiveInput }) => {
  const [upsertLive, { loading }] = useMutation(upsertLiveDocument, {
    refetchQueries: 'active',
  });

  const form = useForm<LiveInput>({
    initialValues: {
      name: live?.name ?? '',
      description: live?.description,
      date: live?.date ?? new Date(),
    },
    validate: {
      name: isNotEmpty('Zadajte názov LIVE!'),
      date: isNotEmpty('Zadajte dátum LIVE!'),
    },
  });

  const handleSubmit = async ({ name, description, date }: typeof form.values) => {
    const { errors } = await upsertLive({
      variables: {
        where: { id: live?.id ?? '' },
        create: { name, description, date },
        update: transformToUpdate({ name, description, date }),
      },
    });

    if (!errors) modals.closeAll();
  };

  return (
    <form onSubmit={form.onSubmit((values) => void handleSubmit(values))}>
      <Stack>
        <TextInput {...form.getInputProps('name')} label="Názov" data-autofocus />
        <TextInput {...form.getInputProps('description')} label="Popis" />
        <DatePickerInput {...form.getInputProps('date')} label="Dátum" valueFormat="DD/MM/YYYY" />
        <Button type="submit" loading={loading}>
          Uložiť
        </Button>
      </Stack>
    </form>
  );
};
